import { render } from "./StarButton.vue?vue&type=template&id=82ef1b0e&scoped=true"
import script from "./StarButton.vue?vue&type=script&lang=js"
export * from "./StarButton.vue?vue&type=script&lang=js"

import "./StarButton.vue?vue&type=style&index=0&id=82ef1b0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82ef1b0e"]])

export default __exports__